import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import UIAbstractRatingInput from 'UIComponents/input/abstract/UIAbstractRatingInput';
import { PillIcon, StarRating, StarRatingFilled, StarRatingEmpty } from './AbstractRatingIcons';
import { STAR_RATING, STAR_RATING_FILLED, STAR_RATING_EMPTY_STATE, PILL_RATING, LabelSizesTemplate } from '../constants/RatingTypes';
export default function AbstractRating(_ref) {
  let {
    'data-test-id': dataTestId,
    direction = 'row',
    height,
    iconSize = 'xs',
    justify,
    label,
    labelSize = 'small',
    rating,
    type = STAR_RATING_FILLED,
    use = 'default'
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["data-test-id", "direction", "height", "iconSize", "justify", "label", "labelSize", "rating", "type", "use"]);

  const flexAlignment = direction === 'row' ? 'center' : 'start';
  const renderedLabel = useMemo(() => {
    if (!label) {
      return null;
    }

    const labelClassName = direction === 'row' ? 'm-left-3' : 'm-top-1';

    if (use === 'card') {
      return /*#__PURE__*/_jsx(Small, {
        className: "m-left-2",
        use: "help",
        children: label
      });
    }

    return /*#__PURE__*/_jsx("span", {
      "data-test-id": `${dataTestId}-label`,
      style: {
        fontSize: LabelSizesTemplate[labelSize]
      },
      className: classNames('rating-label', labelClassName),
      children: label
    });
  }, [dataTestId, label, labelSize, use, direction]);
  const IconComponent = useMemo(() => {
    switch (type) {
      case PILL_RATING:
        return PillIcon;

      case STAR_RATING:
        return StarRating;

      case STAR_RATING_FILLED:
        return StarRatingFilled;

      case STAR_RATING_EMPTY_STATE:
      default:
        return StarRatingEmpty;
    }
  }, [type]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: direction,
    align: flexAlignment,
    justify: justify,
    style: {
      height
    },
    children: [/*#__PURE__*/_jsx(UIAbstractRatingInput, Object.assign({
      className: "display-flex",
      "data-test-id": dataTestId,
      defaultValue: rating,
      IconComponent: IconComponent,
      showPercentage: true // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      size: iconSize,
      value: rating
    }, rest)), renderedLabel]
  });
}